// extracted by mini-css-extract-plugin
module.exports = {"Item":"CarouselItem_Item__3gse_","Link":"CarouselItem_Link__1HcVA"};